import { CommonModule } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormsModule, FormBuilder, Validators,ReactiveFormsModule, ValidationErrors, ValidatorFn, AbstractControl } from '@angular/forms';
import { ProfileService } from './profile.service';
import { AlertComponent } from '../../../alert/alert.component';
import { LoadingModalComponent } from '../../../loading-modal/loading-modal.component';

@Component({
  selector: 'app-profile',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, LoadingModalComponent, AlertComponent],
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss'],
  providers: [ProfileService]
})
export class ProfileComponent implements OnInit {

  //Componentes de alerta e loading
  @ViewChild(AlertComponent) alertComponente!: AlertComponent;
  @ViewChild(LoadingModalComponent) loadingModal !: LoadingModalComponent;


  //Variaveis de listagem de informacoes
  public infoUser: any;
  public formDataProfile: FormGroup;
  public phoneForm : string = '';

  constructor(private profileService: ProfileService, private fb: FormBuilder) {
    this.formDataProfile = this.fb.group({
      nome: ['', [Validators.required]],
      telefone: ['', [Validators.required]],
      cpfcnpj: ['', [Validators.required]],
      host: ['', [Validators.required]], 
      generalKey: [''], // Campo adicionado
      password: ['', [Validators.required, Validators.minLength(3)]],
      confirmarSenha: ['', [Validators.required]]
    }, {
      validators: this.validarSenhas
    });
   }

  ngOnInit() {
    this.profileService.getUser().subscribe((response: any) => {
      this.infoUser = response.user;
      this.formDataProfile.patchValue({
        nome: response.user.nome,
        telefone: this.formatPhone(response.user.telefone),
        cpfcnpj: this.formatDocument(response.user.cpfcnpj),
        host: response.user.host,
        generalKey: response.user.generalKey ?? ''
      })
    }, (error: any) => {
      console.log(error);
    })
  }


  public formatPhone(phone: string): string {

    const apenasNumeros = phone.replace(/\D/g, '');
    if (apenasNumeros.length === 11) {
      return apenasNumeros.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
    } else if (apenasNumeros.length === 10) {
      return apenasNumeros.replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');
    } else {
      return phone;
    }
  }

  public formatDocument(document: string){
    // Remove todos os caracteres não numéricos
  const apenasNumeros = document.replace(/\D/g, '');

  if (apenasNumeros.length === 11) {
    // Formata como CPF: XXX.XXX.XXX-XX
    return apenasNumeros.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
  } else if (apenasNumeros.length === 14) {
    // Formata como CNPJ: XX.XXX.XXX/XXXX-XX
    return apenasNumeros.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
  } else {
    // Retorna a string original se não for CPF nem CNPJ
    return document;
  }
  }

  public updateMaskPhone(){
    this.formDataProfile.patchValue({
      telefone: this.formatPhone(this.formDataProfile.value.telefone)
    })
  }

  public updateMaskCpfCnpj(){
    this.formDataProfile.patchValue({
      cpfcnpj: this.formatDocument(this.formDataProfile.value.cpfcnpj)
    })
  }

  public validarSenhas(formGroup: AbstractControl): Partial<ValidatorFn> | null {
    
    const {password, confirmarSenha} = formGroup.value;
    if(!password || !confirmarSenha) return {paswordMismatch: true}
    return password === confirmarSenha ? null : {passwordMismatch: true}
  }


  public onSubmit(){
    this.loadingModal.activeLoading();

    console.log("Objeto enviado: ",this.formDataProfile.value);
    this.profileService.updateuser(this.formDataProfile.value).subscribe((response: any)=> {
       console.log(response);
       this.alertComponente.showAlert('Usuario alterado com sucesso!', 'success');
       this.loadingModal.inactiveLoading();
    }, (error: any)=>{
      console.log(error);
      this.alertComponente.showAlert(`Erro ao alterar usuario: ${error.error.status}`);
    })
  }

}
